import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { leagueClientSkin } from "../skins/league-client";
import { riotProductSkin } from "../skins/riot-product";
import { Root, Indicator } from "@radix-ui/react-checkbox";
import { Icon } from "../../Icon";
const StylableCheckbox = ({ className, name, defaultChecked = false, onCheckedChange, value, ...htmlProps }) => {
    return (React.createElement(Root, { defaultChecked: defaultChecked, onCheckedChange: onCheckedChange, className: className, id: name, name: name, value: value, ...htmlProps },
        React.createElement(Indicator, { className: "checkbox-indicator", "data-testid": "checkmark" },
            React.createElement(Icon, { name: "square", "data-testid": "checkbox-icon" }))));
};
StylableCheckbox.defaultProps = {
    "data-testid": "checkbox",
};
export const Checkbox = styled(StylableCheckbox) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.LeagueClient]: leagueClientSkin,
})}
`;
//# sourceMappingURL=Checkbox.js.map